import React, { useEffect, useState } from 'react';
import "./Cart.css";
import Button from 'react-bootstrap/esm/Button';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { onSnapshot, updateDoc, doc, deleteDoc, collection } from "@firebase/firestore";
import { onAuthStateChanged } from 'firebase/auth';
import { Link } from 'react-router-dom';
import $ from 'jquery';

function Cart ( props ) {
    let [ itemsArray, setItemsArray ] = useState( [] );
    let [ isFiveDay, setIsFiveDay ] = useState( false );
    let [ totalDisplay, setTotal ] = useState( "0.0" );
    let [ subTotal, setSubTotal ] = useState( "0.0" );
    let [ remainingAmount, setRemainingAmount ] = useState( "0.0" );

    async function onload ( user ) {
        if ( user ) {
            onSnapshot( collection( firestore, "users/" + user.uid + "/cart_items/all_orders_id/all_orders" ), ( snapshot ) => {
                document.querySelector( ".loader-container" ).style.display = "flex";
                let total = 0;
                let ItemsArray = [];
                snapshot.forEach( ( element ) => {
                    if ( element.data().service === "Dry Clean" ) {
                        setIsFiveDay( true );
                    }

                    ItemsArray.push( {
                        name: element.data().category,
                        price: element.data().price,
                        count: element.data().count,
                        uid: element.id
                    } )
                    total += element.data().count * parseFloat( element.data().price );
                } )
                setTotal( total.toFixed( 2 ) );
                setSubTotal( total.toFixed( 2 ) );

                // if ( total < 250 ) {
                //     let remaining = 250 - parseFloat( total.toFixed( 2 ) );
                //     setRemainingAmount( remaining.toFixed( 2 ) );
                //     let subtotal = total + 50;
                //     setSubTotal( 250 );
                // } else {
                //     setRemainingAmount( 0 );
                //     setSubTotal( total.toFixed( 2 ) );
                // }

                setItemsArray( [ ...ItemsArray ] );
                document.querySelector( ".loader-container" ).style.display = "none";
            } )
        }
    }

    async function addQuantity ( uid, count ) {
        updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders", uid ), {
            count: count + 1
        } )
    }

    async function reduceQuantity ( uid, count ) {
        if ( count !== 1 ) {
            await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders", uid ), {
                count: count - 1
            } )
        } else {
            await deleteDoc( doc( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders", uid ) );
        }
    }

    async function deleteItem ( uid ) {
        await deleteDoc( doc( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders", uid ) );
    }

    function slideToggle ( event, index ) {
        let element = document.querySelectorAll( ".cart-faq-content" )[ index ];
        $( element ).slideToggle();
        if ( document.querySelectorAll( ".faq-arrow svg" )[ index ].style.transform === "rotate(180deg)" ) {
            document.querySelectorAll( ".faq-arrow svg" )[ index ].style.transform = "rotate(0deg)";
        } else {
            document.querySelectorAll( ".faq-arrow svg" )[ index ].style.transform = "rotate(180deg)";
        }
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Cart";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile,
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                        onload( user );
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                window.location.href = "/login";
            }
        } )
        setTimeout( () => {
            let width = document.querySelector( ".cart-container" ).clientWidth;
            if ( width > 432 ) {
                let height = document.querySelector( ".cart-faq-container>div:nth-child(2) > div:nth-child(2)" ).clientHeight;
                document.querySelector( ".cart-faq-container>div:nth-child(2) > div:nth-child(1)" ).style.height = height + "px";
            }
        }, 500 )
        window.scrollTo( 0, 0 );
    }, [] )

    return (
        <div className='cart-container'>
            <h5 style={{ fontWeight: "700", color: "grey" }}>Schedule Pickup</h5>
            <h1 style={{ fontWeight: "700" }}>Check Out Your Cart</h1>
            <h6> You don't need to mention the exact Qty. in kg for Wash & Fold and Wash & Iron services. Once your belongings reach our warehouse your clothes will be weighed and an invoice will be sent to you on {props.details.email}.
            </h6>
            <div className='cart-details-container'>
                {itemsArray.map( ( element ) => (
                    <div className='cart-item-container'>
                        <div>
                            <div>
                                <div>{element.name}</div>
                                <div>Rs. {element.price}</div>
                            </div>
                            <div>
                                Quantity - {element.count}
                            </div>
                        </div>
                        <div>
                            <Button variant="secondary" onClick={event => addQuantity( element.uid, element.count )}>
                                <svg width="22" height="23" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className='laptop'>
                                    <path d="M16.5 16.6433V10.6433H19.5V16.6433H25.5V19.6433H19.5V25.6433H16.5V19.6433H10.5V16.6433H16.5ZM18 33.1433C9.71572 33.1433 3 26.4275 3 18.1433C3 9.85904 9.71572 3.14331 18 3.14331C26.2842 3.14331 33 9.85904 33 18.1433C33 26.4275 26.2842 33.1433 18 33.1433ZM18 30.1433C24.6275 30.1433 30 24.7708 30 18.1433C30 11.5159 24.6275 6.14331 18 6.14331C11.3726 6.14331 6 11.5159 6 18.1433C6 24.7708 11.3726 30.1433 18 30.1433Z" fill="white" />
                                </svg>
                                <svg width="16" height="17" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className='mobile'>
                                    <path d="M16.5 16.6433V10.6433H19.5V16.6433H25.5V19.6433H19.5V25.6433H16.5V19.6433H10.5V16.6433H16.5ZM18 33.1433C9.71572 33.1433 3 26.4275 3 18.1433C3 9.85904 9.71572 3.14331 18 3.14331C26.2842 3.14331 33 9.85904 33 18.1433C33 26.4275 26.2842 33.1433 18 33.1433ZM18 30.1433C24.6275 30.1433 30 24.7708 30 18.1433C30 11.5159 24.6275 6.14331 18 6.14331C11.3726 6.14331 6 11.5159 6 18.1433C6 24.7708 11.3726 30.1433 18 30.1433Z" fill="white" />
                                </svg>
                            </Button>
                            <Button variant="secondary" onClick={event => reduceQuantity( element.uid, element.count )}>
                                <svg width="22" height="23" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className='laptop'>
                                    <path d="M18 33.1433C9.71572 33.1433 3 26.4275 3 18.1433C3 9.85904 9.71572 3.14331 18 3.14331C26.2842 3.14331 33 9.85904 33 18.1433C33 26.4275 26.2842 33.1433 18 33.1433ZM18 30.1433C24.6275 30.1433 30 24.7708 30 18.1433C30 11.5159 24.6275 6.14331 18 6.14331C11.3726 6.14331 6 11.5159 6 18.1433C6 24.7708 11.3726 30.1433 18 30.1433ZM10.5 16.6433H25.5V19.6433H10.5V16.6433Z" fill="white" />
                                </svg>
                                <svg width="16" height="17" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className='mobile'>
                                    <path d="M18 33.1433C9.71572 33.1433 3 26.4275 3 18.1433C3 9.85904 9.71572 3.14331 18 3.14331C26.2842 3.14331 33 9.85904 33 18.1433C33 26.4275 26.2842 33.1433 18 33.1433ZM18 30.1433C24.6275 30.1433 30 24.7708 30 18.1433C30 11.5159 24.6275 6.14331 18 6.14331C11.3726 6.14331 6 11.5159 6 18.1433C6 24.7708 11.3726 30.1433 18 30.1433ZM10.5 16.6433H25.5V19.6433H10.5V16.6433Z" fill="white" />
                                </svg>
                            </Button>
                            <Button variant="outline-light" onClick={event => deleteItem( element.uid )}>
                                <svg width="22" height="23" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className='laptop'>
                                    <path d="M25.5 9.14331H33V12.1433H30V31.6433C30 32.4718 29.3284 33.1433 28.5 33.1433H7.5C6.67158 33.1433 6 32.4718 6 31.6433V12.1433H3V9.14331H10.5V4.64331C10.5 3.81489 11.1716 3.14331 12 3.14331H24C24.8284 3.14331 25.5 3.81489 25.5 4.64331V9.14331ZM27 12.1433H9V30.1433H27V12.1433ZM13.5 16.6433H16.5V25.6433H13.5V16.6433ZM19.5 16.6433H22.5V25.6433H19.5V16.6433ZM13.5 6.14331V9.14331H22.5V6.14331H13.5Z" fill="#D60707" />
                                </svg>
                                <svg width="16" height="17" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className='mobile'>
                                    <path d="M25.5 9.14331H33V12.1433H30V31.6433C30 32.4718 29.3284 33.1433 28.5 33.1433H7.5C6.67158 33.1433 6 32.4718 6 31.6433V12.1433H3V9.14331H10.5V4.64331C10.5 3.81489 11.1716 3.14331 12 3.14331H24C24.8284 3.14331 25.5 3.81489 25.5 4.64331V9.14331ZM27 12.1433H9V30.1433H27V12.1433ZM13.5 16.6433H16.5V25.6433H13.5V16.6433ZM19.5 16.6433H22.5V25.6433H19.5V16.6433ZM13.5 6.14331V9.14331H22.5V6.14331H13.5Z" fill="#D60707" />
                                </svg>
                            </Button>
                        </div>
                    </div>
                ) )}
                <div className='cart-payment-container'>
                    <div className='cart-total-container'>
                        <div>
                            Items Total
                        </div>
                        <div>
                            Rs. {totalDisplay}
                        </div>
                    </div>
                    <div className='cart-delivery-container'>
                        <div>
                            Delivery Charge
                        </div>
                        <div>
                            Rs. {"0.0"}
                        </div>
                    </div>
                    <div className='cart-subTotal-container'>
                        <div>
                            Payable Amount
                        </div>
                        <div>
                            Rs. {subTotal}
                        </div>
                    </div>
                    <div className='cart-remaining-container'>
                        <div>
                            As per minimum billing policy if order total is less than &#8377;250 you will charged a minimum amount of &#8377;250.
                        </div>
                    </div>
                </div>
                <div className='cart-button-container'>
                    <Button disabled={itemsArray.length === 0 ? true : false} onClick={event => props.setCartObject( {
                        cart_items: itemsArray,
                        delivery_charge: 0,
                        total: subTotal,
                        isFiveDay: isFiveDay
                    } )}><Link to="/place-order" style={{ color: "white", textDecoration: "none" }}>Schedule Free Pick Up</Link></Button>
                </div>
            </div>
            <div className='cart-faq-container'>
                <div>
                    <h2 style={{ fontWeight: "700" }}>Frequently <font color="#66A9AFAD">asked</font></h2>
                </div>
                <div>
                    <div style={{ overflowY: "scroll" }}>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 0 )}>
                                <span>
                                    Q: Will I get Cashback twice ? First while loading money in Laundry Buddy Wallet and second while making the payment ?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: No ! You get the amazing cashback offers only while loading money in the Laundry Buddy Wallet (i.e. 20% off no order value limit)
                            </div>
                        </div>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 1 )}>
                                <span>
                                    Q: Is Laundry Buddy available for both iOS and Android?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: As of now we're only available for Android Devices. But need not fret there's always the laundry buddy website for all the amazing offers.
                            </div>
                        </div>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 2 )}>
                                <span>
                                    Q: Can I customize my laundry preferences on Laundry Buddy?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: Absolutely! Laundry Buddy allows you to personalize your laundry preferences, such as water temperature, spin cycle, detergent type, and more while scheduling the pickup under "Instructions" tab.
                            </div>
                        </div>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 3 )}>
                                <span>
                                    Q: How does Laundry Buddy work?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: Laundry Buddy is a user-friendly app that helps you manage your laundry tasks efficiently. Simply input your laundry items, set preferences, and track their progress through each stage, from washing to drying to folding.
                            </div>
                        </div>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 4 )}>
                                <span>
                                    Q: I don't know the exact kg of clothes i'm giving for laundry ?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: Absolutely! Laundry Buddy allows you to personalize your laundry preferences, such as water temperature, spin cycle, detergent type, and more while scheduling the pickup under "Instructions" tab.
                            </div>
                        </div>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 5 )}>
                                <span>
                                    Q: Can I track multiple laundry loads simultaneously on Laundry Buddy?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: Yes, you can track multiple laundry loads concurrently with Laundry Buddy. The app supports the management of multiple loads and provides real-time status updates for each one.
                            </div>
                        </div>
                        <div className='cart-faq-content-container'>
                            <div className='cart-faq-content-head' onClick={event => slideToggle( event, 6 )}>
                                <span>
                                    Q: How can I provide feedback or suggestions for Laundry Buddy?
                                </span>
                                <span className='faq-arrow'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='cart-faq-content'>
                                A: We value your feedback and suggestions to improve our app. You can reach out to us through the "Contact" section on our website or within the Laundry Buddy app itself. We appreciate your input!
                            </div>
                        </div>
                    </div>
                    <div>
                        <img src={require( "../../images/faq-image.png" )} alt="" />
                    </div>
                </div>
            </div>
            <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/download-app-banner.webp" )} className='download-app-banner laptop' alt="" /></a>
            <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-mobile.webp" )} className='download-app-banner mobile' alt="" /></a>
        </div>
    )
}

export default Cart